<template>
  <v-layout>
    <v-dialog v-bind:value="show_dialog" @click:outside="$emit('updateDialog', false)" max-width="1100px">
      <v-card style="background-color: #ecf0f5">
        <v-form v-on:submit.prevent="addItems">
          <v-card-title>
            <span class="headline">Remitos</span>
          </v-card-title>

          <v-card-text>
            <div class="row mb-2 mt-0">
              <div class="col-md-12">
                <div class="col-md-12" style="background:white; elevation-0">
                  <div class="row pt-5">
                    <div class="col pt-0">
                      <v-menu
                        ref="desde_selected"
                        v-model="desde_selected_open"
                        :close-on-content-click="false"
                        :close-on-click="false"
                        :return-value.sync="desde_selected"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        clearable
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field dense v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                        </template>
                        <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                          <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <div class="col pt-0">
                      <v-menu
                        ref="hasta_selected"
                        v-model="hasta_selected_open"
                        :close-on-content-click="false"
                        :close-on-click="false"
                        :return-value.sync="hasta_selected"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        clearable
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field dense v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                        </template>
                        <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                          <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <div class="col pt-0">
                      <v-text-field dense clearable v-model="remito_number_selected" autocomplete="off" class="pt-0 mt-0" label="Nº Remito"></v-text-field>
                    </div>

                    <div class="col pt-0">
                      <v-combobox
                        v-model="state_selected"
                        autocomplete="off"
                        data-vv-as="state_selected"
                        name="state_selected"
                        item-text="name"
                        item-value="id"
                        :items="states"
                        label="Estado"
                        v-validate="'combobox'"
                        class="pt-0 mt-0"
                        clearable
                        dense
                      ></v-combobox>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 pt-0 justify-content-end d-flex">
                      <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <v-card>
              <v-card-title style="background: white">
                <v-spacer></v-spacer>
                <v-text-field dense v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="list"
                :search="search"
                :loading="loading"
                loading-text="Cargando..."
                :options="{
                  descending: true,
                  itemsPerPage: 15,
                }"
                @pagination="updatePagination"
                :footer-props="{
                  itemsPerPageOptions: [5, 10, 15, 50, -1],
                }"
              >
                <template v-slot:item="{ item, isSelected, select }">
                  <tr>
                    <td>
                      <v-checkbox :input-value="isSelected" style="margin: 0px; padding: 0px" hide-details @change="select($event)" />
                    </td>
                    <td>{{ item.cbte_fch }}</td>
                    <td>{{ item.remito_label }}</td>
                    <td>{{ item.emitter.name }}</td>
                    <td>{{ item.receiver.name }}</td>
                    <td>{{ item.shipping_carrier != null ? item.shipping_carrier.name : "-" }}</td>
                    <td>{{ item.client_shipping_address != null ? item.client_shipping_address.name : item.shipping_address }}</td>
                    <td class="text-right">{{ item.voucher != null ? item.voucher.voucher_number_label : "-" }}</td>
                    <td class="text-right">{{ item.voucher != null ? formatUtils.formatPrice(item.voucher.imp_neto) : "-" }}</td>
                    <td class="text-right">{{ item.voucher != null ? formatUtils.formatPrice(item.voucher.total_ars) : "-" }}</td>
                  </tr>
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" color="error" icon="warning">
                    {{ "Busqueda sin resultados - " + search }}
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :disabled="selected.length == 0">Agregar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";
import { remitoService } from "@/libs/ws/remitoService";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  mixins: [GenericMixin, ModalGenericMixin],
  props: {
    show_dialog: Boolean,
    carrier: Object,
    addSelected: Function,
  },
  data() {
    return {
      selected: [],
      states: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      remito_number_selected: null,
      state_selected: null,
      desde_selected_open: false,
      hasta_selected_open: false,
      formatUtils: formatUtils,
      headers: [
        { text: "", align: "center", sortable: false, value: "" },
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch" },
        { text: "Nº Remito", align: "left", sortable: true, value: "remito_label" },
        { text: "Emisor", align: "left", sortable: true, value: "emitter.name" },
        { text: "Receptor", align: "left", sortable: true, value: "receiver.name" },
        { text: "Transporte", align: "left", sortable: true, value: "shipping_carrier.name" },
        { text: "Pto de Entrega", align: "left", sortable: true, value: "client_shipping_address.name" },
        { text: "Comprobante", align: "left", sortable: false, value: "voucher.voucher_number_label" },
        { text: "Imp. Neto", align: "right", sortable: true, value: "voucher.imp_neto" },
        { text: "Total ARS", align: "right", sortable: true, value: "voucher.total_ars" },
      ],
    };
  },
  watch: {
    show_dialog() {
      this.selected = [];
      this.errors.clear();
      this.filter();
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    addItems() {
      this.$emit("addSelected", this.selected);
    },
    filter() {
      this.loading = true;
      let filter = {
        from: this.desde_selected,
        to: this.hasta_selected,
        state: this.state_selected != null ? this.state_selected.id : null,
        remito_number: this.remito_number_selected,
        carrier: this.carrier != null ? this.carrier.id : null,
      };
      remitoService
        .filter(filter)
        .then((response) => {
          this.list = response.result;
        })
        .finally(() => {
          this.selected = [];
          this.loading = false;
        });
    },
    loadComboData() {
      remitoService.get_states().then((response) => {
        this.states = response.result;
      });
    },
  },
};
</script>
